import { Pipe, PipeTransform } from '@angular/core';
import { ApiV1_Product, ApiV1_ProductTag } from '@pedix-workspace/api-v1';
import { getUniqueTagsWithQuantities } from '../utils/getUniqueTagsWithQuantities';

@Pipe({
  name: 'pxwProductTagsWithQuantities',
  standalone: true,
})
export class ProductTagsWithQuantitiesPipe implements PipeTransform {
  transform(
    productTagIds: string[],
    activeProducts: ApiV1_Product[],
  ): { productTag: ApiV1_ProductTag; count: number }[] {
    return getUniqueTagsWithQuantities(activeProducts).filter(current =>
      productTagIds.includes(current.productTag.id),
    );
  }
}
